import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ActiveBranchEntity } from '../../domain/entities/ActiveBranchEntity'
import type { WorkingBranchDtoAdmin } from '@/backend/market'

export class ActiveBranchModel extends ActiveBranchEntity {
  constructor(dataDto: WorkingBranchDtoAdmin) {
    super()
    mapEntityProperties<ActiveBranchEntity>(this, dataDto, {
      map: {
        numberOfActiveOrders: dataDto.numberOfActiveDeliveries
      }
    })
  }
}
